import { React, useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import urls, { getCsrfToken } from '../com.zedock.common.script/urls.js';
import { clicks } from '../com.zedock.common.script/common.js';

import '../com.zedock.common.style/Order.css';
import '../com.zedock.common.style/common.css';

function Order() {
  const navigate = useNavigate();
  const userName = localStorage.getItem("userName");
  const [order, setOrder] = useState([]);
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const steps = ["Ordered", "Shipped", "Out for Delivery", "Delivered"];
  const getColor = (step, curr) => {
    if (step == curr)
      return "bg-success";
    else
      return "bg-dark-subtle";
  };

  useEffect(() => {
    clicks(location.pathname);
    window.scrollTo({ top: 0, behavior: 'instant' });

    handleOrder(location);
  }, []);

  async function handleOrder(location) {
    try {

      setLoading(true);

      const response = await
        fetch(`${urls.BASE_URL}` + "/zedock-web/order", {
          headers: {
            "X-XSRF-TOKEN": getCsrfToken()
          },
          method: "GET",
          credentials: "include"
        })
      if (response.status === 401) {
        navigate("/Login", { state: { from: location } });
        localStorage.clear();

        return null;
      }

      const data = await response.json();
      setOrder(data);
    }
    catch (error) {

    } finally {
      setLoading(false);
    }
  };

  const getProduct = async (productId) => {
    try {
      setLoading(true);
      const response = await
        fetch(`${urls.BASE_URL}` + "/zedock-web/product/" + productId, {

          headers: {
            "X-XSRF-TOKEN": getCsrfToken()
          },
          method: "GET",
          credentials: "include"   // ✅ send JSESSIONID cookie
        });
      const data = await response.json();
      navigate("/Specifications", { state: data })
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container px-0    ">

      <div className="zd-wrap p-2 p-lg-4">

        <div className="row g-0">
          <nav aria-label="breadcrumb" className="zd-crumb">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <a href="" onClick={(e) => { e.preventDefault(); navigate("/Product") }}>Home</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">Order</li>
            </ol>
          </nav>
        </div>
        <div className="row     g-2 mb-2">

          <div className="zd-order-head">
            <span className="zd-order-eyebrow">Order status</span>
            <h2>Track order</h2>
          </div>

          <div className="zd-greeting">
            Hi <span>{order?.[0] == null ? "Guest" : userName}</span>, here's where your orders stand.
          </div>
        </div>

        {loading ? (
          <div className="zd-loader-wrap text-center py-5">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <div className='almost-ready'> Almost ready!</div>
          </div>
        ) : (
          <div className="row     g-2 mb-2">
            {order.map((item) => (
              <div key={item.id} className="zd-order-card  g-2">
                <span className="zd-span">Checkout #{item.id} | Date: {item.addedAt}</span>

                {item.orderArray.map((itemOder) => (
                  <div key={itemOder.orderId} className="zd-order-card row g-2 m-2">
                    {/* image */}
                    <div className="col-6 col-lg-2">
                      <div className="zd-order-thumb">
                        <img src={urls.CDN_URL + 'products_thumb/' + itemOder.productSku + '.webp'} alt={itemOder.productName}
                          onClick={() => getProduct(itemOder.productId)}
                        />
                      </div>
                    </div>

                    {/* order info */}
                    <div className="col-6 col-lg-2">
                      <h6>{itemOder.productName}</h6>
                      <div>
                        <p className="zd-order-meta">Price: <strong>₹{itemOder.productPrice}</strong></p>
                        <p className="zd-order-meta">  Quantity: <strong>{itemOder.quantity}</strong></p>

                      </div>
                    </div>



                    {/* description */}
                    <div className="col-12 col-lg-4">
                      <div className="zd-desc-block">
                        <p className="zd-desc-label">Product description</p>
                        <p className="zd-desc-text">{itemOder.productDescription}</p>
                      </div>
                    </div>

                    {/* status stepper */}
                    <div className="col-12 col-lg-4">
                      <span className="zd-status-badge"><span className="dot"></span>{itemOder.status}</span>
                      <span className="zd-status-badge">Order #{itemOder.orderId}</span>




                      <div className="zd-stepper">
                        <div className="zd-stepper-line"></div>
                        <div className="zd-stepper-row">
                          {steps.map((step) => (
                            <div key={step} className="zd-stepper-step">
                              <div className={`zd-stepper-dot ${getColor(step, itemOder.status)}`}></div>
                              <small>{step}</small>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                  </div>
                ))}

              </div>
            ))}
          </div>
        )
        }
      </div>

    </div >
  );
}

export default Order;
